import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { clientSecretSelector } from '../../../core/redux/stripe/selectors';

const styles = () => ({
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const StripeLoader = ({ clientSecret, classes }) => {
  if (clientSecret) {
    return null;
  }

  return (
    <div className={classes.loader}>
      <CircularProgress />
    </div>
  );
};

StripeLoader.propTypes = {
  classes: PropTypes.shape({
    loader: PropTypes.string.isRequired,
  }).isRequired,
  clientSecret: PropTypes.string,
};

const mapStateToProps = state => ({
  clientSecret: clientSecretSelector(state),
});

const enhanced = compose(
  withStyles(styles),
  connect(mapStateToProps)
);

export default enhanced(StripeLoader);
